import { defineMessages } from 'react-intl';
import type { ConfigType } from '@plone/registry';
import installSettings from './config/settings';
import favicon from './static/favicon.ico';
import iconSvg from './static/icon.svg';
import appleTouchIcon from './static/apple-touch-icon.png';

import { ReggioEmiliaWelcomeBlocks } from 'iovisit-reggioemiliawelcome/config/blocks';
import ross1000strutture from 'iovisit-reggioemiliawelcome/reducers/ross1000strutture';
import ross1000Comuni from './reducers/ross1000comuni';

function applyConfig(config: ConfigType) {
  installSettings(config);
  config.settings.iovisit = {
    // @ts-ignore
    ...config.settings.iovisit,
    siteName: 'Reggio Emilia Welcome',
    eventsCitiesVocabulary: 'iovisit.reggioemiliawelcome.cities',
  };

  config.settings.markSpecialLinks = true;

  // @ts-ignore
  config.settings.iovisit.topLink.text =
    'Sito ufficiale di informazione turistica del Comune di Reggio Emilia';

  config.settings.isMultilingual = true;
  config.settings.supportedLanguages = ['it', 'en'];
  config.settings.defaultLanguage = 'it';

  // @ts-ignore
  config.settings.iovisit.favicon = [
    { rel: 'icon', sizes: 'any', href: favicon },
    { rel: 'icon', sizes: 'any', href: iconSvg },
    { rel: 'icon', sizes: 'any', href: appleTouchIcon },
  ];

  config.settings['volto-gdpr-privacy'] = {
    ...config.settings['volto-gdpr-privacy'],
    defaultPanelConfig: {
      ...config.settings['volto-gdpr-privacy'].defaultPanelConfig,
      profiling: {
        ...config.settings['volto-gdpr-privacy'].defaultPanelConfig.profiling,
        choices: [],
      },
    },
  };

  config.blocks.blocksConfig = {
    ...config.blocks.blocksConfig,
    ...ReggioEmiliaWelcomeBlocks,
  };

  config.addonReducers = {
    ...config.addonReducers,
    ross1000strutture: ross1000strutture,
    ross1000comuni: ross1000Comuni,
  };

  const originalTeaserSchemaEnhancer =
    config.blocks.blocksConfig.gridBlock.blocksConfig.teaser.schemaEnhancer;

  config.blocks.blocksConfig.gridBlock.blocksConfig.teaser = {
    ...config.blocks.blocksConfig.gridBlock.blocksConfig.teaser,
    schemaEnhancer: (props) => {
      const schema = originalTeaserSchemaEnhancer
        ? originalTeaserSchemaEnhancer(props)
        : props.schema;

      props.schema.fieldsets[0].fields = [
        ...props.schema.fieldsets[0].fields,
        'center-text',
      ];

      props.schema.properties = {
        ...props.schema.properties,
        'center-text': {
          type: 'boolean',
          title: props.intl?.formatMessage(messages.centerText),
        },
      };
      return schema;
    },
  };

  return config;
}

const messages = defineMessages({
  centerText: {
    id: 'centerText',
    defaultMessage: 'Centra il testo',
  },
});

export default applyConfig;
